import React, { forwardRef } from "react";
import { cleanClassNames } from "../../../helpers/classNames";
import { SearchBarProps } from "../../../helpers/types";
import "./style.scss";

const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(
  (
    {
      className,
      placeholder,
      searchedData,
      handleSearch,
      showIcon,
      onKeyDown,
      onFocus,
    },
    ref,
  ) => {
    return (
      <div
        className={cleanClassNames(
          "ui-search-container",
          showIcon ? "show-icon" : "",
          className,
        )}
      >
        <input
          ref={ref}
          className={className}
          placeholder={placeholder}
          type="text"
          onChange={handleSearch}
          value={searchedData}
          name="search"
          onKeyDown={onKeyDown}
          onFocus={onFocus}
        />
        {showIcon && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            data-testid="search-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        )}
      </div>
    );
  },
);

export default SearchBar;
